import {connect} from 'react-redux';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {batch} from '../../../helpers/reduxHelpers';
import {CalendarEventVersionResponse} from '../../../models/api/calendarEventVersionModel';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../services/tracking';
import {AppState} from '../../../store/appState';
import {Dispatch} from '../../../store/appStore';
import {
  RecurringEventSaveTypesEnum,
  replyToCalendarEventVersionAction,
} from '../../../store/data/calendarEventVersions/calendarEventVersionsActions';
import {makeGetMasterCalendarEventVersion} from '../../../store/data/dataSelectors';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarEventViewerFooter} from './calendarEventViewerFooter';

/*
 * Props.
 */

interface CalendarEventViewerFooterContainerProps {
  calendarEventData: CalendarEventData;
  response: CalendarEventVersionResponse;
  onRecurringSaveTypeSelection: Handler;
}

/*
 * Selectors.
 */

function getFocusedCalendarEventData(_state: AppState, props: CalendarEventViewerFooterContainerProps) {
  return props.calendarEventData;
}

const getMasterCalendarEventVersion = makeGetMasterCalendarEventVersion(getFocusedCalendarEventData);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CalendarEventViewerFooterContainerProps>()(() => ({
  masterCalendarEventVersion: getMasterCalendarEventVersion,
}));

const mapDispatchToProps = (dispatch: Dispatch, props: CalendarEventViewerFooterContainerProps) => ({
  onResponseClick: (
    newResponse: CalendarEventVersionResponse,
    recurringSaveType?: RecurringEventSaveTypesEnum,
  ) => {
    const {calendarEventData, response, onRecurringSaveTypeSelection} = props;
    const {calendarEventVersion, calendarVersion, instanceStartDate} = calendarEventData;
    if (!response || (newResponse.status === response.status && newResponse.comment === response.comment)) {
      return;
    }

    batch(() => {
      dispatch(
        replyToCalendarEventVersionAction({
          calendarEventVersionUid: calendarEventVersion.uid,
          response: newResponse,
          calendarVersionId: calendarVersion.id,
          recurringSaveType,
          instanceStartDate,
        }),
      );

      if (recurringSaveType) {
        dispatch(onRecurringSaveTypeSelection);
      }
    });

    trackInterfaceEvent(InterfaceEventsEnum.MARK_RESPONSE_STATUS, {
      status: newResponse.status,
      has_comment: Boolean(newResponse.comment),
    });
  },
});

export const CalendarEventViewerFooterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CalendarEventViewerFooter);
